export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";